import { GET_CHATS } from '@/hooks/query/useQueryChats';
import { invalidateWorkflowRunQueries } from '@heidi/agents/data';
import type { QueryClient } from '@tanstack/react-query';

/** Refetch workflow run lists plus app-shell caches tied to agent-event completion. */
export const invalidateShellCachesOnEvent = (queryClient: QueryClient): void => {
  invalidateWorkflowRunQueries(queryClient);
  void queryClient.invalidateQueries({ queryKey: ['projects', 'list'] });
  void queryClient.invalidateQueries({ queryKey: [GET_CHATS] });
};
